import get from 'lodash/get'
import groupBy from 'lodash/groupBy'
import { Fragment, useMemo } from 'react'
import { defineMessages, FormattedMessage, useIntl } from 'react-intl'
import { getTextFromInfo } from '../../../../utils'

const messages = defineMessages({
  dynamicPackage: {
    id: 'account.booking.dives_type_in_total',
    defaultMessage:
      '{qty} {diveType} {qty, plural, one { dive } other { dives }} in total',
  },
  fixedUnlimitedPackage: {
    id: 'ulimited_shore_dives',
    defaultMessage: 'Unlimited shore dives',
  },
  fixedDivesPackage: {
    id: 'account.booking.dives_in_total',
    defaultMessage:
      '{qty} {qty, plural, one { dive } other { dives }} in total',
  },
  perDiverPackage: {
    id: 'account.booking.dives_type_per_diver',
    defaultMessage:
      '{qty} {diveType} {qty, plural, one { dive } other { dives }} per diver',
  },
})

const PackageDives = ({ order }) => {
  const intl = useIntl()
  const { isDynamicPackages, packageDiveKind, diveType, dives } = order
  const divesAmount = get(order, 'divesInfo.totalDives', 0)
  const divesTypeTitle = getTextFromInfo(diveType, 'shop', 'DIVE_TYPE')

  const hasAdditionalUnlimitedDives =
    !isDynamicPackages && packageDiveKind === 20

  const showDetailedDivesInfo =
    order.divers > 1 && (isDynamicPackages || packageDiveKind !== 30)

  const divesAmountTitle = useMemo(() => {
    if(!isDynamicPackages) {
      return packageDiveKind === 30
        ? messages.fixedUnlimitedPackage
        : messages.fixedDivesPackage
    }

    return messages.dynamicPackage
  }, [isDynamicPackages, packageDiveKind])

  const groupedByNumberDives = Object.values(
    groupBy(dives, 'numberOfInstances')
  )

  return (
    <div className='price-pan__group mbn mtn'>
      <div className='price-pan__body__row'>
        <div className='title lower'>
          <i className='font-icons check-icon' />
          <span>
            {intl.formatMessage(divesAmountTitle, {
              diveType: divesTypeTitle,
              qty: divesAmount,
            })}
          </span>
          {hasAdditionalUnlimitedDives && (
            <span>{intl.formatMessage(messages.fixedUnlimitedPackage)}</span>
          )}
        </div>
        <div className='quantity' />
        <div className='total-price green'>
          <FormattedMessage id='included' defaultMessage='Included' />
        </div>
      </div>

      {showDetailedDivesInfo && (
        <Fragment>
          {groupedByNumberDives.map((dives, i) => (
            <div className='price-pan__body__row' key={`dives_${i}`}>
              <div className='title plm'>
                <small>
                  <i className='font-icons check-icon' />
                  {intl.formatMessage(messages.perDiverPackage, {
                    diveType: divesTypeTitle,
                    qty: dives[0].numberOfInstances,
                  })}
                </small>
              </div>
              <div className='quantity'>{dives.length}</div>
              <div className='total-price' />
            </div>
          ))}
        </Fragment>
      )}
    </div>
  )
}

export default PackageDives
